import { Dispatch, useCallback } from 'react';
import {
  LocationChoice,
  renderLocationChoice,
} from '../../../../../common/components/SearchHeader/types/LocationChoice';
import { safeMemo } from '../../../../../common/util/safeMemo';
import { LocationListItem, StyledMapMarker } from '../LocationFilter.styles';

export const LocationFilterItem = safeMemo(
  ({ choice, onChoose, index, selected, onSelect }: Props) => {
    const handleClick = useCallback(() => onChoose?.(choice), [choice, onChoose]);
    return (
      <LocationListItem
        data-testid="location-list-item"
        onClick={handleClick}
        onMouseEnter={() => onSelect(index)}
        aria-selected={selected}
      >
        <StyledMapMarker />
        <span>
          {choice.suburb &&
            `${choice.suburb.name}, ${choice.suburb.state || ''} ${choice.suburb.postcode || ''}`}
          {!choice.suburb && renderLocationChoice(choice)}
        </span>
      </LocationListItem>
    );
  },
);

interface Props {
  choice: LocationChoice;
  onChoose?: Dispatch<LocationChoice>;
  index: number;
  selected: boolean;
  onSelect: Dispatch<number>;
}
